export default __webpack_public_path__ + "static/media/address.910a0180.jpg";